
import React from 'react';
import { WeatherCondition } from '@/types/weather';
import AnimatedWeatherIcon from './AnimatedWeatherIcon';

interface WeatherIconProps {
  condition: WeatherCondition;
  size?: "sm" | "md" | "lg";
  animated?: boolean;
}

/**
 * A wrapper component for backward compatibility
 * This preserves the existing API while using the refactored components
 */
export const WeatherIcon: React.FC<WeatherIconProps> = (props) => {
  return <AnimatedWeatherIcon {...props} />;
};

export default WeatherIcon;
